require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-teri-hockett.json") })
        }
      }, "path---blog-author-teri-hockett");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-teri-hockett!./.cache/json/blog-author-teri-hockett.json
// module id = 710
// module chunks = 231608221292675